import { getCompanyInfo } from "@/model/CompanyInfo";

export const CUSTOM_FONT_COMPANY_ID = [920];

export const getFontFaceList = (fontFaceList: any[]) => {
  const customFontFaceList = [];
  const companyInfo = getCompanyInfo();

  if (CUSTOM_FONT_COMPANY_ID.includes(companyInfo.id || 0)) {
    customFontFaceList.push({
      name: 'Tenor Sans',
      value: 'Tenor Sans, sans-serif',
    });
  }

  return [
    ...customFontFaceList,
    ...fontFaceList,
  ];
};
